import { render, staticRenderFns } from "./LazyBackground.vue?vue&type=template&id=be7d983e&scoped=true&"
import script from "./LazyBackground.vue?vue&type=script&lang=js&"
export * from "./LazyBackground.vue?vue&type=script&lang=js&"
import style0 from "./LazyBackground.vue?vue&type=style&index=0&id=be7d983e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7d983e",
  null
  
)

export default component.exports